(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-reviews"] && !window.DesignMode) return;
  try {
    
   var maxIndex = null;
$('.progressBarContainer').each(function() {
  var maxValue = parseFloat($(this).find('.progressBar').attr('data-slick-index'));
  maxIndex = (maxValue > maxIndex) ? value : maxIndex;
});

  } catch(e) { console.error(e); }
})();
})();
